module.exports = __webpack_public_path__ + "static/fonts/BMEuljiro10yearslater.ttf?aadbb96f";